import { isStoreError } from './store-type-guards'
import { StoreError } from './store-types'

export const parseStoreException = (err: Error | StoreError) => {
	return isStoreError(err) ? err.error : err
}

export const unwrapStoreException = (apiError: StoreError) => apiError.error
